import { ChangeDetectorRef, Component } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { AppService } from '../../app.service';
import { catchError, finalize, tap } from 'rxjs';
import { NotificationSchedulesService } from '../../services/notification-schedules/notification-schedules.service';
import { isArrayWithData } from '../../utilities/array.helpers';
import { getTimeFromDateHHMMSS } from '../../utilities/date.helpers';

const DAYS_OPTIONS = [
    {
        name: 'SUN',
        value: 'Sunday',
    },
    {
        name: 'MON',
        value: 'Monday',
    },
    {
        name: 'TUE',
        value: 'Tuesday',
    },
    {
        name: 'WED',
        value: 'Wednesday',
    },
    {
        name: 'THU',
        value: 'Thursday',
    },
    {
        name: 'FRI',
        value: 'Friday',
    },
    {
        name: 'SAT',
        value: 'Saturday',
    },
];
@Component({
    selector: 'app-notification-schedules',
    templateUrl: './notification-schedules.component.html',
    styleUrl: './notification-schedules.component.css',
})
export class NotificationSchedulesComponent {
    isSideBarVisible: boolean = false;
    isDeleteModalVisible: boolean = false;
    toDeleteItem: any;
    editedId: number = 0;
    selectedCreditorId: string = '';
    creditorCompanyName: string = '';
    notificationSchedules!: any[];

    firstName: string = '';
    lastName: string = '';
    email: string = '';

    dayOptions: any;
    selectedDay: any;
    preferredTime: any;
    startTime: any;
    endTime: any;
    editedSchedule: any;
    isActive: boolean = false;
    hasClickedSearch: boolean = false;

    public constructor(
        private etlIngestionService: EtlIngestionService,
        private appService: AppService,
        private notificationSchedulesService: NotificationSchedulesService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.resetForm();

        const currentSession = this.appService.getCurrentSession();
    }

    get hasTableData(): boolean {
        return isArrayWithData(this.notificationSchedules);
    }

    onSelectCreditor(event: any) {
        this.hasClickedSearch = false;
        this.notificationSchedules = [];
        this.selectedCreditorId = event.CreditorId;
        this.creditorCompanyName = event.CompanyName;
    }

    search() {
        if (!!this.selectedCreditorId) {
            //this.getMockData();

            this.appService.isShowPageSpinner = true;
            this.notificationSchedulesService
                .get(this.selectedCreditorId)
                .pipe(
                    tap((res: any) => {
                        if (isArrayWithData(res)) {
                            this.notificationSchedules = res;
                        }
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                        this.hasClickedSearch = true;
                    }),
                )
                .subscribe();
        }
    }

    getMockData() {
        this.notificationSchedules = [
            {
                notificationScheduleId: 43,
                creditorId: 2,
                day: 'Sunday',
                preferredTimeUtc: '00:00:00',
                startTimeUtc: '00:00:00',
                endTimeUtc: '00:00:00',
                isActive: false,
                createdOnUtc: '2024-09-17T15:09:00',
                createdBy: 'RavenExport',
                updatedOnUtc: null,
                updatedBy: null,
                deletedOnUtc: null,
                deletedBy: null,
            },
            {
                notificationScheduleId: 44,
                creditorId: 2,
                day: 'Monday',
                preferredTimeUtc: '14:00:00',
                startTimeUtc: '11:00:00',
                endTimeUtc: '17:00:00',
                isActive: true,
                createdOnUtc: '2024-09-17T15:09:00',
                createdBy: 'RavenExport',
                updatedOnUtc: null,
                updatedBy: null,
                deletedOnUtc: null,
                deletedBy: null,
            },
            {
                notificationScheduleId: 45,
                creditorId: 2,
                day: 'Tuesday',
                preferredTimeUtc: '14:00:00',
                startTimeUtc: '11:00:00',
                endTimeUtc: '17:00:00',
                isActive: true,
                createdOnUtc: '2024-09-17T15:09:00',
                createdBy: 'RavenExport',
                updatedOnUtc: null,
                updatedBy: null,
                deletedOnUtc: null,
                deletedBy: null,
            },
            {
                notificationScheduleId: 46,
                creditorId: 2,
                day: 'Wednesday',
                preferredTimeUtc: '14:00:00',
                startTimeUtc: '11:00:00',
                endTimeUtc: '17:00:00',
                isActive: true,
                createdOnUtc: '2024-09-17T15:09:00',
                createdBy: 'RavenExport',
                updatedOnUtc: null,
                updatedBy: null,
                deletedOnUtc: null,
                deletedBy: null,
            },
            {
                notificationScheduleId: 47,
                creditorId: 2,
                day: 'Thursday',
                preferredTimeUtc: '14:00:00',
                startTimeUtc: '11:00:00',
                endTimeUtc: '17:00:00',
                isActive: true,
                createdOnUtc: '2024-09-17T15:09:00',
                createdBy: 'RavenExport',
                updatedOnUtc: null,
                updatedBy: null,
                deletedOnUtc: null,
                deletedBy: null,
            },
            {
                notificationScheduleId: 48,
                creditorId: 2,
                day: 'Friday',
                preferredTimeUtc: '14:00:00',
                startTimeUtc: '11:00:00',
                endTimeUtc: '17:00:00',
                isActive: true,
                createdOnUtc: '2024-09-17T15:09:00',
                createdBy: 'RavenExport',
                updatedOnUtc: null,
                updatedBy: null,
                deletedOnUtc: null,
                deletedBy: null,
            },
            {
                notificationScheduleId: 49,
                creditorId: 2,
                day: 'Saturday',
                preferredTimeUtc: '14:00:00',
                startTimeUtc: '11:00:00',
                endTimeUtc: '17:00:00',
                isActive: true,
                createdOnUtc: '2024-09-17T15:09:00',
                createdBy: 'RavenExport',
                updatedOnUtc: null,
                updatedBy: null,
                deletedOnUtc: null,
                deletedBy: null,
            },
        ];
    }

    formatTime(time: string | null): Date | null {
        if (!time || time === '00:00:00') return null;
        return this.getDateWithTime(time);
    }

    onOpenSideBar(schedule: any = null) {
        if (!!this.selectedCreditorId) {
            setTimeout(() => {
                const svgElement = document.querySelector(
                    '.p-dropdown-trigger-icon',
                ) as SVGElement | null;
                if (svgElement) {
                    svgElement.style.fill = 'white';
                    svgElement.style.color = 'white';
                }

                const trigger = document.querySelector(
                    '.p-dropdown-trigger',
                ) as HTMLElement | null;
                if (trigger) {
                    trigger.style.color = 'white';
                }
            }, 1000);

            if (schedule) {
                this.dayOptions = [
                    DAYS_OPTIONS.find((i) => i.value === schedule.day),
                ];
                this.isSideBarVisible = true;
                this.editedSchedule = schedule;
                this.editedId = schedule.notificationScheduleId;
                this.preferredTime = this.getDateWithTime(
                    schedule.preferredTimeUtc,
                );
                this.startTime = this.getDateWithTime(schedule.startTimeUtc);
                this.endTime = this.getDateWithTime(schedule.endTimeUtc);
                this.isActive = schedule.isActive;
                this.selectedDay = this.dayOptions[0];
            } else {
                if (
                    !this.notificationSchedules ||
                    this.notificationSchedules.length < 7
                ) {
                    if (isArrayWithData(this.notificationSchedules)) {
                        const daysAlreadyUsed = this.notificationSchedules.map(
                            (rowSched: any) => rowSched.day,
                        );

                        const newDayOptions = DAYS_OPTIONS.filter(
                            (dayOption: any) =>
                                !daysAlreadyUsed.includes(dayOption.value),
                        );
                        console.log('newDayOptions:', newDayOptions);
                        this.dayOptions = newDayOptions;
                    } else {
                        this.dayOptions = DAYS_OPTIONS;
                        console.log(
                            'this.dayOptions = DAY_OPTIONS:',
                            DAYS_OPTIONS,
                        );
                    }
                    this.isSideBarVisible = true;
                    this.resetForm();
                }
            }
        }
    }

    resetForm = () => {
        const now = new Date();
        this.preferredTime = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            10,
            0,
            0,
        );
        this.startTime = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            10,
            0,
            0,
        );
        this.endTime = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            10,
            0,
            0,
        );
        this.isActive = false;

        this.selectedDay = null;
        this.editedId = 0;
        this.editedSchedule = null;
    };

    getDateWithTime = (time: any) => {
        const now = new Date();
        const [hours, minutes, seconds] = time.split(':').map(Number);
        return new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            hours,
            minutes,
            seconds,
        );
    };

    onSave() {
        const newPreferredTime = getTimeFromDateHHMMSS(this.preferredTime);
        const newStartTime = getTimeFromDateHHMMSS(this.startTime);
        const newEndTime = getTimeFromDateHHMMSS(this.endTime);

        this.appService.isShowPageSpinner = true;
        if (!this.editedId && !!this.selectedCreditorId) {
            this.notificationSchedulesService
                .post(
                    parseInt(this.selectedCreditorId),
                    this.selectedDay.value,
                    newPreferredTime,
                    newStartTime,
                    newEndTime,
                    this.isActive,
                )
                .pipe(
                    tap((res: any) => {
                        setTimeout(() => {
                            this.appService.showCommonMessageDialog(
                                'Success',
                                'Notification Schedule has been successfully created.',
                            );
                            this.isSideBarVisible = false;
                            this.appService.isShowPageSpinner = false;
                            this.search();
                        }, 2000);
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {}),
                )
                .subscribe();
        } else {
            this.notificationSchedulesService
                .put(
                    this.editedId,
                    parseInt(this.selectedCreditorId),
                    this.selectedDay.value,
                    newPreferredTime,
                    newStartTime,
                    newEndTime,
                    this.isActive,
                    this.editedSchedule.createdBy,
                    this.editedSchedule.createdOnUtc,
                )
                .pipe(
                    tap(() => {
                        //@refresh is not working so will refresh page in the meantime
                        // const newNotificationSchedules = this.notificationSchedules.map((item: any) => {
                        //   if (item.NotificationScheduleId === this.editedId) {
                        //     item.day = this.selectedDay.value,
                        //     item.preferredTimeUtc = newPreferredTime
                        //     item.startTimeUtc = newStartTime,
                        //     item.endTimeUtc = newEndTime;
                        //     item.isActive = this.isActive;
                        //   }
                        //   return item;
                        // });
                        // this.notificationSchedules = newNotificationSchedules;
                        // this.cdr.detectChanges();

                        setTimeout(() => {
                            this.appService.showCommonMessageDialog(
                                'Success',
                                'Notification Schedule has been successfully updated.',
                            );
                            this.isSideBarVisible = false;
                            this.appService.isShowPageSpinner = false;
                            this.search();
                        }, 1000);
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {}),
                )
                .subscribe();
        }
    }
}
